import clsx from 'clsx'

import { AddToComparison, useIsInComparison } from '@/features/product/AddToComparison'
import { AddToFavorires, useIsInFavorites } from '@/features/product/AddToFavorites'

import { CardData } from '@/entities/card'

import cl from './TopController.module.scss'

interface TopControllerProps {
	itemClassName: string
	productCode: string
	sectionId: number
	changeCompareIcon?: boolean
	data: CardData
}

export const TopController = (props: TopControllerProps) => {
	const { productCode, sectionId, itemClassName, changeCompareIcon, data } = props

	const isInFavorites = useIsInFavorites(productCode)
	const isInComparison = useIsInComparison(productCode)

	const favoriteButtonClasses = clsx(itemClassName, {
		[cl.isVisibleAnyway]: isInFavorites
	})

	const comparisonButtonClasses = clsx(itemClassName, {
		[cl.isVisibleAnyway]: isInComparison && !changeCompareIcon
	})

	return (
		<>
			<AddToFavorires data={data} productCode={productCode} className={favoriteButtonClasses} />
			<AddToComparison
				productCode={productCode}
				sectionId={sectionId}
				className={comparisonButtonClasses}
				changeCompareIcon={changeCompareIcon}
				data={data}
			/>
		</>
	)
}
